import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e36b9ce7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel-inner h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradient left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradient right" }, null, -1))
const _hoisted_4 = ["data-bs-target"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "carousel slide",
    ref: "el",
    id: $setup.id
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    ($props.count === undefined || $props.count > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("button", {
            class: "control carousel-control-prev",
            type: "button",
            "data-bs-target": '#' + $setup.id,
            "data-bs-slide": "prev"
          }, _hoisted_7, 8, _hoisted_4),
          _createElementVNode("button", {
            class: "control carousel-control-next",
            type: "button",
            "data-bs-target": '#' + $setup.id,
            "data-bs-slide": "next"
          }, _hoisted_11, 8, _hoisted_8)
        ], 64))
      : _createCommentVNode("", true)
  ], 512))
}